import { getCustomers } from 'store/customers/actions'
import type { GetCustomersPayload } from 'store/customers/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'
import type { Customers } from 'types'

import { useQuerySelect } from 'hooks'



type UseCustomersParams = GetCustomersPayload

type UseCustomersResult = {
  data: Customers | null
} & UseQuerySelectResult<UseCustomersParams>

export const useCustomers = (params: UseCustomersParams, options?: UseQuerySelectOptions): UseCustomersResult => {
  const result = useQuerySelect(getCustomers, params, options)

  const data = useSelector(state => state.customers.customers)

  return {
    data,
    ...result,
  }
}
